import { MoengageInstance } from '@services/moengage-service';
import { Component, Element, Event, EventEmitter, h, Prop, State, Watch } from '@stencil/core';
import { If } from '@utils/If';

@Component({
  tag: 'profile-dropdown',
  styleUrl: 'profile-dropdown.scss',
  shadow: true
})
export class ProfileDropdown {
  @Prop() assetPath: string;
  @Prop() firstname: string;
  @Prop() redirectDomainUrl: string = '';
  @Prop() customLogout: boolean = false;
  @Event() logout: EventEmitter<void>;

  @State() showDropdown: boolean = false;
  @State() dropDownList = [];
  @Element() hostElement: HTMLElement;

  @Watch('showDropdown')
  watchShowDropdown(newValue: boolean) {
    if (typeof document === 'undefined') return;

    if (newValue) {
      document.addEventListener('click', this.handleClickOutside);
    } else {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  componentWillLoad() {
    this.dropDownList = [
      {
        title: 'My Profile',
        subtitle: "Update your profile, payment methods, and traveller details",
        link: this.redirectDomainUrl + 'my_profile',
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21"><g transform="translate(-.5 -.5)"><circle cx="3" cy="3" r="3" data-name="Ellipse 1567" style={{ fill: 'none', stroke: '#555', strokeLinecap: 'round', strokeLinejoin: 'round' }} transform="translate(8 8)" /><path d="M17.727 13.727a1.5 1.5 0 0 0 .3 1.655l.055.055a1.819 1.819 0 1 1-2.573 2.573l-.055-.055a1.512 1.512 0 0 0-2.564 1.073v.155a1.818 1.818 0 1 1-3.636 0V19.1a1.5 1.5 0 0 0-.982-1.373 1.5 1.5 0 0 0-1.655.3l-.055.055a1.819 1.819 0 1 1-2.573-2.573l.055-.055a1.512 1.512 0 0 0-1.073-2.564h-.153a1.818 1.818 0 0 1 0-3.636H2.9a1.5 1.5 0 0 0 1.373-.982 1.5 1.5 0 0 0-.3-1.655l-.055-.055a1.819 1.819 0 1 1 2.573-2.571l.055.055a1.5 1.5 0 0 0 1.655.3h.073a1.5 1.5 0 0 0 .909-1.373v-.155a1.818 1.818 0 0 1 3.636 0V2.9a1.512 1.512 0 0 0 2.564 1.073l.055-.055a1.819 1.819 0 1 1 2.573 2.573l-.055.055a1.5 1.5 0 0 0-.3 1.655v.073a1.5 1.5 0 0 0 1.373.909h.155a1.818 1.818 0 1 1 0 3.636H19.1a1.5 1.5 0 0 0-1.373.908z" data-name="Path 14670" style={{ fill: 'none', stroke: '#555', strokeLinecap: 'round', strokeLinejoin: 'round' }} /></g></svg>,
      },
      {
        title: 'My Orders/ Bookings',
        subtitle: "View Order details, Download ticket, Cancel booking, Check refund status",
        link: this.redirectDomainUrl + 'manage_orders',
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M0 0h20v20H0z" data-name="Rectangle 6378" style={{ fill: 'none' }} /><g data-name="Group 42883"><path d="M5.882 2 3 5.834v10.831a1.919 1.919 0 0 0 1.922 1.917h13.45a1.919 1.919 0 0 0 1.922-1.917V5.834L17.411 2z" data-name="Path 14671" style={{ stroke: '#555', strokeLinecap: 'round', strokeLinejoin: 'round', fill: 'none' }} transform="translate(-1.747 -.391)" /><path d="M0 0h15.564" data-name="Line 1035" style={{ stroke: '#555', strokeLinecap: 'round', strokeLinejoin: 'round', fill: 'none' }} transform="translate(2.119 5.06)" /><path d="M15.686 10A3.843 3.843 0 0 1 8 10" data-name="Path 14672" style={{ stroke: '#555', strokeLinecap: 'round', strokeLinejoin: 'round', fill: 'none' }} transform="translate(-1.942 -.723)" /></g></svg>,
      },
      {
        title: 'Customer Support',
        subtitle: "Get 24X7 support on bookings, returns, or travel-related inquiries",
        link: this.redirectDomainUrl + 'customer_support',
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><g data-name="Group 42878"><path d="M0 0h20v20H0z" data-name="Rectangle 6375" style={{ fill: 'none' }} /><circle cx="8.5" cy="8.5" r="8.5" data-name="Ellipse 1566" style={{ stroke: '#555', strokeLinecap: 'round', strokeLinejoin: 'round', fill: 'none' }} transform="translate(1 1)" /><path d="M9.09 8.784a2.677 2.677 0 0 1 5.2.892c0 1.784-2.677 2.677-2.677 2.677v1.334" data-name="Path 14667" style={{ stroke: '#555', strokeLinecap: 'round', strokeLinejoin: 'round', fill: 'none' }} transform="translate(-1.886 -1.661)" /><path d="M0 0h0" data-name="Line 1033" style={{ stroke: '#555', strokeLinecap: 'round', strokeLinejoin: 'round', fill: 'none' }} transform="translate(10 15)" /></g></svg>,
      },
      {
        title: 'FAQ’s',
        link: this.redirectDomainUrl + 'faqs',
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" fill="none"><path fill="#1C1B1F" d="M10.5 11.55c.2 0 .38-.08.538-.238a.768.768 0 0 0 .237-.562c0-.2-.079-.38-.237-.538a.744.744 0 0 0-.538-.237.74.74 0 0 0-.537.237.743.743 0 0 0-.238.538c0 .217.08.404.238.562a.74.74 0 0 0 .537.238Zm-.45-2.825h.9c.017-.417.08-.733.188-.95.108-.217.362-.508.762-.875.433-.4.733-.75.9-1.05.167-.3.25-.642.25-1.025 0-.683-.242-1.25-.725-1.7-.483-.45-1.092-.675-1.825-.675-.55 0-1.042.15-1.475.45-.433.3-.767.717-1 1.25l.825.35c.183-.4.413-.696.688-.888a1.64 1.64 0 0 1 .962-.287c.483 0 .88.142 1.188.425.308.283.462.65.462 1.1 0 .267-.075.517-.225.75-.15.233-.408.517-.775.85-.433.367-.725.704-.875 1.012-.15.309-.225.73-.225 1.263ZM5.125 14c-.467 0-.854-.154-1.162-.462-.309-.309-.463-.696-.463-1.163V1.625c0-.467.154-.854.463-1.163C4.271.154 4.658 0 5.125 0h10.75c.467 0 .854.154 1.163.462.308.309.462.696.462 1.163v10.75c0 .467-.154.854-.462 1.163-.309.308-.696.462-1.163.462H5.125Zm0-1h10.75a.597.597 0 0 0 .437-.188.597.597 0 0 0 .188-.437V1.625a.597.597 0 0 0-.188-.437.597.597 0 0 0-.437-.188H5.125a.597.597 0 0 0-.437.188.597.597 0 0 0-.188.437v10.75c0 .167.063.312.188.437s.27.188.437.188Zm-3 4c-.467 0-.854-.154-1.163-.462C.654 16.229.5 15.842.5 15.375V3.625h1v11.75c0 .167.063.312.188.437s.27.188.437.188h11.75v1H2.125Z" /></svg>,

      },
      {
        title: 'Logout',
        link: this.redirectDomainUrl + 'logout',
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><g data-name="Group 42881"><path d="M0 0h20v20H0z" data-name="Rectangle 6376" style={{ fill: 'none' }} /><g data-name="Group 42880"><path d="M9.7 20.6H5.235A2.216 2.216 0 0 1 3 18.4V5.2A2.216 2.216 0 0 1 5.235 3H9.7" data-name="Path 14668" style={{ stroke: '#555', strokeLinecap: 'round', strokeLinejoin: 'round', fill: 'none' }} transform="translate(-1.801 -1.8)" /><g data-name="Group 42879"><path d="m16 15.483 4.317-4.242L16 7" data-name="Path 14669" style={{ stroke: '#555', strokeLinecap: 'round', strokeLinejoin: 'round', fill: 'none' }} transform="translate(-1.519 -1.242)" /><path d="M10.103 0H0" data-name="Line 1034" style={{ stroke: '#555', strokeLinecap: 'round', strokeLinejoin: 'round', fill: 'none' }} transform="translate(8.697 10)" /></g></g></g></svg>,


      }
    ];
  }

  onShowDropDown(event: MouseEvent) {
    event.stopPropagation();
    this.showDropdown = !this.showDropdown;
  }

  private handleClickOutside = (event: MouseEvent) => {
    const clickedInside = this.hostElement.contains(event.target as Node);
    if (!clickedInside) {
      this.showDropdown = false;
    }
  };

  async onClickListItem(event: MouseEvent, item: any) {
    if (item.title === 'Logout') {
      event.preventDefault();
      await MoengageInstance.destroySession();
      if (this.customLogout) {
        this.logout.emit();
      } else {
        window.location.href = `${this.redirectDomainUrl}logout`;
      }

    }
  }


  render() {
    return (
      <div onClick={event => this.onShowDropDown(event)} class={'flex relative items-center gap-2 cursor-pointer gap-3'}>
        <linear-gradrient>
          <div class={'flex items-center justify-center profile rounded-full '}>
            <span class="font-bold">{this.firstname ? this.firstname.charAt(0).toUpperCase() : ''}</span>
          </div>
        </linear-gradrient>
        <div>
          <img alt="profile dropdown" src={`${this.assetPath}icons/dropdownIcon.svg`} />
        </div>
        <If
          condition={this.showDropdown}
          children={
            <div class="absolute slide-in-top z-20 top-full right-0 bg-white border border-solid border-gray-800 rounded-lg w-80 max-w-[90vw]">
              <map-component
                items={this.dropDownList}
                renderItem={(item, index) => (
                  <a
                    onClick={(event: any) => this.onClickListItem(event, item)}
                    href={item.link}
                    key={index}
                    class={`p-4 block text-gray-700 ${index !== 0 && 'border-t'} text-sm border-gray-300`}
                  >
                    <div class="flex items-start gap-2">
                      <div class="flex items-center flex-shrink-0 mt-1">
                        {item.icon}
                      </div>
                      <div class="flex flex-col min-w-0 flex-1">
                        <span class="whitespace-nowrap ">{item.title}</span>
                        <If
                          condition={item.subtitle}
                          children={
                            <span class="block text-xs text-gray-500 mt-1 break-words">
                              {item.subtitle}
                            </span>
                          }
                        />
                      </div>
                    </div>
                  </a>
                )}
              />
            </div>

          }
        />
      </div>
    );
  }
}
